module.exports = __webpack_public_path__ + "static/media/logo.70cc52d5.svg";